import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-integration-twilio',
  templateUrl: './integration-twilio.component.html',
  styleUrls: ['./integration-twilio.component.css']
})
export class IntegrationTwilioComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
